/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxFrontOpenIcon16Solid = forwardRef('DeliveryBoxFrontOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m.386 5.713.793-2.644A1.5 1.5 0 0 1 2.616 2H9.5l-.759 3.794A1.5 1.5 0 0 1 7.271 7H1.343a1 1 0 0 1-.958-1.287Z" }),
        React.createElement("path", { d: "M9.5 2h3.884a1.5 1.5 0 0 1 1.437 1.069l.793 2.644A1 1 0 0 1 14.656 7H11.73a1.5 1.5 0 0 1-1.471-1.206L9.5 2Z" }),
        React.createElement("path", { d: "M9 8H2v4a2 2 0 0 0 2 2h5V8Z" }),
        React.createElement("path", { d: "M14 8h-4v6h2a2 2 0 0 0 2-2V8Z" })));
});
